export const CHUNK_SIZE = 32;

export const BASE_PATH = VUE_APP_BASE_PATH; // eslint-disable-line no-undef
export const BASE_URL = VUE_APP_BASE_URL; // eslint-disable-line no-undef
export const API_URL = VUE_APP_API_URL; // eslint-disable-line no-undef

export const MONTH_NAMES = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
];

export const MONTH_NAMES_ACCUSATIVE = [
  "Января",
  "Февраля",
  "Марта",
  "Апреля",
  "Мая",
  "Июня",
  "Июля",
  "Августа",
  "Сентября",
  "Октября",
  "Ноября",
  "Декабря",
];

export const WEEKDAY_NAMES = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];

export const CONTRACT_STATUS_NAMES = {
  none: "Не заключен",
  service: "Активен",
  suspended: "Приостановлен",
  terminated: "Расторгнут",
  concluding: "Не заключен", // assert: is_offer == true
};

export const MARGIN_CONFIRMATION_BLOCK = {
  concluding: {
    text: 'Для заключения договора необходимо ознакомиться с документами, подписать их и оплатить гарантийный взнос — ',
    confirmation: 'Для подтверждения оплаты гарантийного взноса загрузите платежное поручение',

  },
  is_offer: {
    text: 'Для принятия оферты нужно передать необходимые документы и данные, также оплатить гарантийный взнос — ',
    confirmation: 'Для подтверждения принятия оферты загрузите платежное поручение об оплате гарантийного взноса',
  }
}
